<template lang="html">

  <transition name="modal-fade">
    <div class="modal-background" v-show="messageBoxVisible">

      <div id="message-box" class="white-box" role="dialog">

        <h1 id="message-box-headline">{{ headline }}</h1>

        <div id="message-box-text" ref="messageArea" aria-label="Meddelelse">
          <p v-html="message"></p>
        </div>

        <button type="button" id="message-box-cancel-btn" class="btn grey col-5" @click="closeMessageBox();" v-show="cancelBtnText != false">
            {{ cancelBtnText }}
        </button>
        <button type="button" id="message-box-confirm-btn" class="btn blue col-5" @click="confirm();">
            {{ btnText }}
        </button>

      </div>

    </div>
  </transition>
</template>

<script>
import { EventBus } from '@/main.js'

export default {
  data() {
    return {
      messageBoxVisible: false,
      headline: 'Overskrift',
      message: '',
      btnText: 'Ok',
      cancelBtnText: false,
      callback: false,
      callbackType: false,
    }
  },
  created() {
    EventBus.$on('openMessageBox', (options) => {
      this.headline = options.headline || '';
      this.message = options.message;
      this.btnText = options.btnText || 'Ok';
      this.cancelBtnText = options.cancelBtnText || false;

      if(options.callbackType != undefined) {
        this.callback = options.callback;
        this.callbackType = options.callbackType;
      }

      this.showMessageBox();
    });
  },
  mounted() {
    this.$refs.messageArea.addEventListener('click', this.checkLink);
  },
  methods: {
    checkLink(event) {
      event.preventDefault();
      var href = event.target.href;
      if(href != undefined) {
        if(href.indexOf('odenserundt.dk') != -1) {
          let split = href.split('odenserundt.dk');
  				this.$router.push(split[1]);
        }
        else {
          window.open(href, '_system', '');
        }
      }
    },

    confirm() {
      if(this.callback) {
        if(this.callbackType == 'link') {
          this.$router.push(this.callback);
        }
        else if(this.callbackType == 'function') {
          this.callback();
        }
      }
      this.closeMessageBox();
    },

    showMessageBox() {
      this.messageBoxVisible = true;
      this.$HelperFunctions.setScreenReaderFocus('message-box-headline');
    },
    
    closeMessageBox() {
      this.messageBoxVisible = false;
      this.callback = false;
      this.callbackType = false;
    }
  }
}
</script>

<style lang="css" scoped>
  #message-box {
    /*position: fixed;*/
    height: auto;
    width: 300px;
    z-index: 10000;
    overflow-x: auto;
    /*display: flex;
    flex-direction: column;*/
    text-align: center;
    padding: 10px;
  }

  #message-box-headline {
    font-size: 22px;
  }

  #message-box-text {
    display: inline-block;
  	margin-top: 10px;
  	margin-bottom: 10px;
  }

  p {
    margin: 0px;
  }

  #message-box-confirm-btn, #message-box-cancel-btn {
  	display: inline-block;
  	position: relative;
  	border-radius: 2px;
  }

  #message-box-cancel-btn {
    margin-right: 10px;
  }

  footer {
    padding: 10px;
  }
</style>
